import {
  endOfMonth,
  startOfMonth,
  startOfQuarter,
  startOfWeek,
  startOfYear,
  subDays,
  subMonths,
  subQuarters,
  subWeeks,
  subYears
} from 'date-fns';
import { getFormattedDateString } from './date.helper';

export interface IDaterangeAuswahl {
  range: DaterangeAuswahlMenu;
  label: string;
  fromDate: Date;
  toDate: Date;
  fromDateString: string;
  toDateString: string;
}

export interface IDaterange {
  fromDate?: Date;
  toDate?: Date;
}

export enum DaterangeAuswahlMenu {
  AktuellesQuartal,
  AktuellesMonat,
  AktuellesJahr,
  AktuelleWoche,
  LetztesQuartal,
  LetztesMonat,
  LetztesJahr,
  LetzteWoche
}

export function createDateranges(): IDaterangeAuswahl[] {
  return [
    createRange(DaterangeAuswahlMenu.AktuelleWoche, aktuelleWoche),
    createRange(DaterangeAuswahlMenu.AktuellesMonat, aktuellesMonat),
    createRange(DaterangeAuswahlMenu.AktuellesQuartal, aktuellesQuartal),
    createRange(DaterangeAuswahlMenu.AktuellesJahr, aktuellesJahr),
    createRange(DaterangeAuswahlMenu.LetzteWoche, letzteWoche),
    createRange(DaterangeAuswahlMenu.LetztesMonat, letztesMonat),
    createRange(DaterangeAuswahlMenu.LetztesQuartal, letztesQuartal),
    createRange(DaterangeAuswahlMenu.LetztesJahr, letztesJahr)
  ];
}

function createRange(range: DaterangeAuswahlMenu, rangeFn: (date?: Date) => IDaterange): IDaterangeAuswahl {
  const daterange = rangeFn();
  return {
    range,
    label: daterangeAuswahlMenuLabel[range],
    ...daterange,
    fromDateString: getFormattedDateString(daterange.fromDate),
    toDateString: getFormattedDateString(daterange.toDate)
  } as IDaterangeAuswahl;
}

export const daterangeAuswahlMenuLabel = {
  [DaterangeAuswahlMenu.AktuelleWoche]: 'Aktuelle Woche',
  [DaterangeAuswahlMenu.AktuellesQuartal]: 'Aktuelles Quartal',
  [DaterangeAuswahlMenu.AktuellesMonat]: 'Aktuelles Monat',
  [DaterangeAuswahlMenu.AktuellesJahr]: 'Aktuelles Jahr',
  [DaterangeAuswahlMenu.LetzteWoche]: 'Letze Woche',
  [DaterangeAuswahlMenu.LetztesQuartal]: 'Letzes Quartal',
  [DaterangeAuswahlMenu.LetztesMonat]: 'Letzes Monat',
  [DaterangeAuswahlMenu.LetztesJahr]: 'Letzes Jahr'
};

export function aktuellesQuartal(date = new Date()): IDaterange {
  return {
    fromDate: startOfQuarter(date),
    toDate: undefined
  };
}

export function aktuellesJahr(date = new Date()): IDaterange {
  return {
    fromDate: startOfYear(date),
    toDate: undefined
  };
}

export function aktuellesMonat(date = new Date(), mitToDate = false): IDaterange {
  return {
    fromDate: startOfMonth(date),
    toDate: mitToDate ? endOfMonth(date) : undefined
  };
}

export function aktuelleWoche(date = new Date()): IDaterange {
  return {
    fromDate: startOfWeek(date, { weekStartsOn: 1 }),
    toDate: undefined
  };
}

export function letztesJahr(date = new Date()): IDaterange {
  return {
    fromDate: subYears(startOfYear(date), 1),
    toDate: subDays(startOfYear(date), 1)
  };
}

export function letztesQuartal(date = new Date()): IDaterange {
  return {
    fromDate: subQuarters(startOfQuarter(date), 1),
    toDate: subDays(startOfQuarter(date), 1)
  };
}

export function letztesMonat(date = new Date()): IDaterange {
  return {
    fromDate: subMonths(startOfMonth(date), 1),
    toDate: subDays(startOfMonth(date), 1)
  };
}

export function letzteWoche(date = new Date()): IDaterange {
  return {
    fromDate: subWeeks(startOfWeek(date, { weekStartsOn: 1 }), 1),
    toDate: subDays(startOfWeek(date, { weekStartsOn: 1 }), 1)
  };
}
